import WanderingBoundaryLocation from 'features/wandering-boundary-settings/domain/models/wandering-boundary-location';
import { useReadWanderingBoundaryLocations } from 'features/wandering-boundary-settings/domain/queries/wandering-boundary-settings-queries';
import useWanderingBoundarySettingsDetailsState, {
  WanderingBoundarySettingsDetailsState,
} from 'features/wandering-boundary-settings/providers/states/wandering-boundary-settings-details-state';

export type WanderingBoundarySettingsState = {
  readWanderingBoundaryLocationsIsLoading: boolean;
  readWanderingBoundaryLocationsData: WanderingBoundaryLocation[] | undefined;
  readWanderingBoundaryLocationsIsFetching: boolean;

  detailsState: WanderingBoundarySettingsDetailsState;
};

const useWanderingBoundarySettingsProviderState = (): WanderingBoundarySettingsState => {
  const wanderingBoundarySettingsDetailsState = useWanderingBoundarySettingsDetailsState();

  const {
    isLoading: readWanderingBoundaryLocationsIsLoading,
    data: readWanderingBoundaryLocationsData,
    isFetching: readWanderingBoundaryLocationsIsFetching,
  } = useReadWanderingBoundaryLocations();

  return {
    readWanderingBoundaryLocationsData,
    readWanderingBoundaryLocationsIsFetching,
    readWanderingBoundaryLocationsIsLoading,
    detailsState: wanderingBoundarySettingsDetailsState,
  };
};

export default useWanderingBoundarySettingsProviderState;
